// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"ddc3352e","787":"21a7402e"}[chunkId] + ".chunk.js";
};